import { PayloadAction } from '@reduxjs/toolkit';
import { Order, OrderList } from './type';
import { OrderState } from './state';

const reducers = {
  setAllOrders(
    state: OrderState,
    action: PayloadAction<OrderList[]>,
  ): OrderState {
    state.orders = action.payload;
    return state;
  },
  setOrder(state: OrderState, action: PayloadAction<Order>): OrderState {
    state.order = action.payload;
    return state;
  },
};

export default reducers;
